import { gql } from '@apollo/client';

//TODO add prof graphql
export const ADD_PROF = gql`
  mutation addProf(
    $username: String!
    $lastname: String!
    $firstname: String
    $tel: String
    $email: String!
    $password: String
    $classes: [ID]
    $role: ID
    $isPairTeacher: Boolean
    $blocked: Boolean
  ) {
    createUsersPermissionsUser(
      data: {
        username: $username
        lastname: $lastname
        firstname: $firstname
        tel: $tel
        email: $email
        password: $password
        classes: $classes
        role: $role
        isPairTeacher: $isPairTeacher
        blocked: $blocked
      }
    ) {
      data {
        id
        attributes {
          email
          firstname
          lastname
          mdp
          username
        }
      }
    }
  }
`;
